<app-page titolo="Categorie" [sottotitolo]="sottotitolo()">
  <button azioni type="button" mat-flat-button color="primary" (click)="new()">
    <mat-icon>add</mat-icon>
    Nuova categoria
  </button>

  <div class="filtri">
    <mat-form-field class="filtri__ricerca">
      <mat-label>Cerca per nome</mat-label>
      <input matInput [formControl]="filtroNome" autocomplete="off" />
      @if (filtroNome.value) {
        <button type="button" matSuffix mat-icon-button aria-label="Svuota la ricerca" (click)="filtroNome.setValue('')">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>

    <div class="filtri__scelte filtri__scelte--aperte">
      <mat-form-field class="filtri__stato">
        <mat-label>Rubrica</mat-label>
        <mat-select [formControl]="filtroRubrica">
          <mat-option [value]="null">Tutte</mat-option>
          <mat-option value="1">Solo rubriche</mat-option>
          <mat-option value="0">Solo categorie</mat-option>
        </mat-select>
      </mat-form-field>

      @if (filtriAttivi()) {
        <button type="button" mat-button (click)="azzeraFiltri()">Azzera filtri</button>
      }
    </div>
  </div>

  <app-data-table
    [columnDefinitions]="columnDefinitions"
    [pageSizeOptions]="[25, 50, 100]"
    [caricamento]="caricamento()"
    [errore]="errore()"
    [rigaCliccabile]="true"
    etichettaVuoto="Nessuna categoria."
    (rigaScelta)="edit($event)"
    (pageChange)="search(true)"
    (pageSizeChange)="search()"
    (sortChange)="search()"
    (onInit)="search()"
  />
</app-page>

<ng-template #rubricaCella let-categoria>
  @if (categoria.rubrica === '1') {
    <span class="etichetta-chip">Rubrica</span>
  }
</ng-template>

<ng-template #azioniCella let-categoria>
  <button type="button" mat-icon-button aria-label="Modifica" (click)="$event.stopPropagation(); edit(categoria)">
    <mat-icon>edit</mat-icon>
  </button>
</ng-template>

<ng-template #detailsModal>
  <h2 mat-dialog-title>{{ editItem?.id ? 'Modifica categoria' : 'Nuova categoria' }}</h2>

  <mat-dialog-content>
    <form class="modulo" [formGroup]="editItemForm">
      <mat-form-field class="modulo__largo">
        <mat-label>Nome</mat-label>
        <input matInput formControlName="nome" />
      </mat-form-field>

      <mat-form-field class="modulo__largo">
        <mat-label>Permalink</mat-label>
        <input matInput formControlName="permalink" />
        <mat-hint>Compare nell'indirizzo delle pagine del sito.</mat-hint>
      </mat-form-field>

      <mat-form-field class="modulo__largo">
        <mat-label>È una rubrica</mat-label>
        <mat-select formControlName="rubrica">
          <mat-option value="0">No</mat-option>
          <mat-option value="1">Sì</mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <!-- L'eliminazione esisteva anche su un elemento nuovo, dove non ha niente
         da eliminare, e aveva lo stesso aspetto di "Salva". -->
    @if (editItem?.id) {
      <button type="button" mat-button class="modulo__elimina" (click)="elimina()">Elimina</button>
    }
    <span class="modulo__spazio"></span>
    <button type="button" mat-button mat-dialog-close>Annulla</button>
    <button type="button" mat-flat-button color="primary" (click)="save()">Salva</button>
  </mat-dialog-actions>
</ng-template>
